"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyDataSourceParameterType = exports.parseDataSourceParameterType = exports.deserializeDataSourceParameterType = exports.serializeDataSourceParameterType = void 0;
const dataSource_1 = require("./dataSource");
// export const convertStringToDataSourceParameterType = (value: string): DataSourceParameterType => {
//   const dataSourceParameterType = Object.values(DataSourceParameterType).find((v) => v === value);
//   return dataSourceParameterType || DataSourceParameterType.STRING;
// };
// export const GetDataSourceParameterTypeFromString = (type: string): DataSourceParameterType => {
//   return DataSourceParameterType[type as keyof typeof DataSourceParameterType];
// };
// TODO: Think of a better approach to support custom value inputs
const serializeDataSourceParameterType = (dataSourceParameterType) => dataSourceParameterType.toString();
exports.serializeDataSourceParameterType = serializeDataSourceParameterType;
const deserializeDataSourceParameterType = (dataSourceParameterTypeStr) => {
    switch (dataSourceParameterTypeStr) {
        case 'String':
            return dataSource_1.DataSourceParameterType.STRING;
        case 'Int':
            return dataSource_1.DataSourceParameterType.INT;
        case 'Float':
            return dataSource_1.DataSourceParameterType.FLOAT;
        case 'DateTime':
            return dataSource_1.DataSourceParameterType.DATE_TIME;
        case '[String]':
            return dataSource_1.DataSourceParameterType.ARRAY_OF_STRINGS;
        case '[Int]':
            return dataSource_1.DataSourceParameterType.ARRAY_OF_INTS;
        case '[Float]':
            return dataSource_1.DataSourceParameterType.ARRAY_OF_FLOATS;
        default:
            return dataSource_1.DataSourceParameterType.STRING;
    }
};
exports.deserializeDataSourceParameterType = deserializeDataSourceParameterType;
const parseDataSourceParameterType = (paramType, value) => {
    switch (paramType) {
        case dataSource_1.DataSourceParameterType.INT:
            return parseInt(value, 10);
        case dataSource_1.DataSourceParameterType.FLOAT:
            return parseInt(value);
        case dataSource_1.DataSourceParameterType.ARRAY_OF_STRINGS:
            return value.split(',');
        case dataSource_1.DataSourceParameterType.ARRAY_OF_INTS:
            return value
                .split(',')
                .map((e) => parseInt(e, 10))
                .filter((e) => !isNaN(e) && Number.isInteger(e));
        case dataSource_1.DataSourceParameterType.ARRAY_OF_FLOATS:
            return value
                .split(',')
                .map((e) => parseFloat(e))
                .filter((e) => !isNaN(e));
        case dataSource_1.DataSourceParameterType.DATE_TIME:
            return new Date(value);
        default:
            return value;
    }
};
exports.parseDataSourceParameterType = parseDataSourceParameterType;
const stringifyDataSourceParameterType = (paramType, value) => {
    switch (paramType) {
        case dataSource_1.DataSourceParameterType.INT:
        case dataSource_1.DataSourceParameterType.FLOAT:
            return value.toString();
        case dataSource_1.DataSourceParameterType.ARRAY_OF_STRINGS:
            if (typeof value === 'string') {
                value = [value];
            }
            return value.join(',');
        case dataSource_1.DataSourceParameterType.ARRAY_OF_INTS:
        case dataSource_1.DataSourceParameterType.ARRAY_OF_FLOATS:
            if (typeof value === 'string' || typeof value === 'number') {
                value = [value];
            }
            return value.map((e) => e.toString()).join(',');
        default:
            return value;
    }
};
exports.stringifyDataSourceParameterType = stringifyDataSourceParameterType;
//# sourceMappingURL=serdes.js.map